function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m456 8.5h-368c-17.671875 0-32 14.328125-32 32v40h352c17.671875 0 32 14.328125 32 32v184h16c17.671875 0 32-14.328125 32-32v-224c0-17.671875-14.328125-32-32-32zm0 0",
  fill: "#85D2D5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m440 112.5c0-17.671875-14.328125-32-32-32h-368c-17.671875 0-32 14.328125-32 32v24h432zm0 0",
  fill: "#85D2D5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 216.5v120c0 17.671875 14.328125 32 32 32h368c17.671875 0 32-14.328125 32-32v-120zm0 0",
  fill: "#85D2D5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 136.5h432v80h-432zm0 0",
  fill: "#EB6324"
}), /*#__PURE__*/React.createElement("path", {
  d: "m456 .5h-368c-22.082031.027344-39.972656 17.917969-40 40v32h-8c-22.082031.027344-39.9726562 17.917969-40 40v224c.0273438 22.082031 17.917969 39.972656 40 40h368c22.082031-.027344 39.972656-17.917969 40-40v-32h8c22.082031-.027344 39.972656-17.917969 40-40v-224c-.027344-22.082031-17.917969-39.972656-40-40zm-416 88h368c13.253906 0 24 10.746094 24 24v24h-416v-24c0-13.253906 10.746094-24 24-24zm392 248c0 13.253906-10.746094 24-24 24h-368c-13.253906 0-24-10.746094-24-24v-120h416zm48-72c0 13.253906-10.746094 24-24 24h-8v-176c-.027344-22.082031-17.917969-39.972656-40-40h-344v-32c0-13.253906 10.746094-24 24-24h368c13.253906 0 24 10.746094 24 24zm0 0",
  fill: "#EB6324"
}));

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -59 496 495",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card.6cdbd16a.svg";
export { ForwardRef as ReactComponent };